import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const slug = pathSegments[1];
    const categoryMap: Record<string, string> = {
      'film-tv': '影视圈',
      'music': '音乐圈',
      'influencer': '网红圈',
      'variety': '综艺',
      'fashion': '时尚',
      'sports': '体育',
      'international': '国际',
      'exclusive': '独家',
    };
    items.push({ label: categoryMap[slug] || slug, href: location.pathname });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    items.push({ label: '文章详情' });
  } else if (pathSegments[0] === 'about') {
    items.push({ label: '关于我们' });
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center gap-1.5 text-xs text-foreground-500">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
              {item.href && index < items.length - 1 ? (
                <Link to={item.href} className="hover:text-primary-500 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}